/**
 * @file SSODetailsTab.js
 * @description SSO Details tab component for the Client SSO Wizard.
 */

import {
  fetchSSOInitiationTypes,
  fetchSSOVendorEnvironments,
  fetchSSOAttributeValues,
  fetchCertificateById,
  fetchTenantSSOStatuses,
} from "./ssoService";

export const computeGlobalSummary = async (ssoData, isMultiTenant = false) => {
  try {
    const [
      initiationTypes,
      vendorEnvironments,
      attributeValues,
      tenantSSOStatuses,
    ] = await Promise.all([
      fetchSSOInitiationTypes(),
      fetchSSOVendorEnvironments(),
      fetchSSOAttributeValues(),
      fetchTenantSSOStatuses(),
    ]);

    const [signingCert, encryptionCert] = await Promise.all([
      ssoData.signingCertificateId
        ? fetchCertificateById(ssoData.signingCertificateId)
        : null,
      ssoData.encryptionCertificateId
        ? fetchCertificateById(ssoData.encryptionCertificateId)
        : null,
    ]);

    const getValueFromLookup = (lookupArray, id) => {
      const item = lookupArray.find((item) => item.id === id);
      return item ? item.name : "";
    };

    const ssoAttributes = isMultiTenant
      ? ssoData.ssoAttributes
      : ssoData.tenantSSOAttributes;

    const summaryArray = ssoAttributes.map((attr) => ({
      ssoName: ssoData.name,
      initiatedBy: getValueFromLookup(
        initiationTypes,
        ssoData.ssoInitiationTypeId
      ),
      vendorEnv: getValueFromLookup(
        vendorEnvironments,
        ssoData.ssoVendorEnvironmentId
      ),
      status: isMultiTenant
        ? ssoData.isActive
          ? "Active"
          : "Inactive"
        : getValueFromLookup(tenantSSOStatuses, ssoData.tenantSSOStatusId),
      attribute: attr.attribute,
      value:
        getValueFromLookup(attributeValues, attr.ssoAttributeValueId) ||
        attr.literal,
      description: attr.description,
      signingCert: signingCert.name || signingCert?.fileName || "",
      encryptionCert: encryptionCert.name || encryptionCert?.fileName || "",
      encryptionExp: encryptionCert?.expirationDate
        ? new Date(encryptionCert.expirationDate).toLocaleDateString()
        : "",
    }));

    return summaryArray;
  } catch (error) {
    console.error("Error computing global summary:", error);
    throw error;
  }
};